import styled from 'styled-components';

const Container = styled.div`
   {
    background-color: var(--secondary-background-color);
       margin: 0;
`;
export default Container;
